import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCurrentUser } from './useCurrentUser';
import { useNostrPublish } from './useNostrPublish';

/**
 * NIP-09 event deletion request (kind 5).
 * Publishes a kind 5 event referencing the event(s) to delete.
 * Note: deletion is a request — relays may or may not honour it.
 */
export function useNostrDelete() {
  const { user } = useCurrentUser();
  const { mutateAsync: publishEvent } = useNostrPublish();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      eventIds,
      reason,
    }: {
      eventIds: string[];
      reason?: string;
    }) => {
      if (!user) throw new Error('Must be logged in to delete events');

      await publishEvent({
        kind: 5,
        content: reason ?? '',
        tags: eventIds.map((id) => ['e', id]),
      });
    },
    onSuccess: () => {
      // Invalidate all relevant queries so UI refreshes
      queryClient.invalidateQueries();
    },
  });
}
